module.exports = "<ccd-event-log [events]=\"caseField.value\"></ccd-event-log>"